import {FastRobotErrorcode} from 'constants/dataEnum';

export const toBase64Promise = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const toTextPromise = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const validateFileData = (file) => {
  let isValid = true;
  let errorCode = '';
  let payload = null;

  if (!file?.size) {
    isValid = false;
  } else if (file.type === 'text/plain') {
    const reader = new FileReader();
    reader.onload = () => {
      const decoder = new TextDecoder('utf-8');
      const convertedResponse = new Uint8Array(reader.result);
      const responseCode = convertedResponse[0];
      payload = decoder.decode(convertedResponse.slice(1));

      if (responseCode !== FastRobotErrorcode.NoError) {
        errorCode = responseCode;
        isValid = false;
      }
    };
    reader.readAsArrayBuffer(file);
  }

  return {isValid, errorCode, payload};
};

export const getFileName = (file) => {
  let filename = '';
  const header = file?.headers['content-disposition'];

  if (!header) return filename;

  // Try to match filename* (RFC 5987, handles UTF-8 and encoding)
  let match = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i);

  if (match && match[1]) {
    filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
  } else {
    // Fallback to regular filename
    match = header.match(/filename="?([^"]+)"?/i);

    if (match && match[1]) {
      [, filename] = match;
    }
  }

  // Remove extension
  const lastDot = filename.lastIndexOf('.');

  if (lastDot > 0) {
    filename = filename.substring(0, lastDot);
  }

  return filename;
};
